import { useMemo } from 'react';
import { isNumber, isString, toNumber } from 'lodash-es';
import { formatEther } from 'viem';
import { useSession } from '../contexts';
import {
  useUserBalanceAPIQuery,
  useUserBalanceBlockchainQuery,
} from '../services/queries';
import { useIsBlockchainVersion } from './useIsBlockchainVersion.ts';

export const useUserBalance = () => {
  const { isAuthenticated } = useSession();
  const blockchainVersion = useIsBlockchainVersion();

  const { data: apiBalanceData, ...restAPIBalanceResponse } =
    useUserBalanceAPIQuery({
      enabled: isAuthenticated && !blockchainVersion,
    });

  const { data: blockchainData, ...restBlockchainBalanceResponse } =
    useUserBalanceBlockchainQuery({
      enabled: blockchainVersion,
    });

  return useMemo(() => {
    if (blockchainVersion) {
      return {
        ...restBlockchainBalanceResponse,
        data: blockchainData?.value
          ? parseFloat(formatEther(blockchainData.value))
          : 0,
      };
    }

    const data = isNumber(apiBalanceData?.data.balance)
      ? apiBalanceData?.data.balance
      : isString(apiBalanceData?.data.balance)
        ? toNumber(apiBalanceData?.data.balance)
        : undefined;

    return {
      ...restAPIBalanceResponse,
      data,
    };
  }, [
    blockchainVersion,
    restAPIBalanceResponse,
    restBlockchainBalanceResponse,
    apiBalanceData,
    blockchainData,
  ]);
};
